import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useState,
} from 'react';
import classNames from 'classnames';

import {
  Fieldset,
  Toggle,
  DateField,
  ToggleGroup,
} from '@ktag/styleguide/dist/react';

import {
  FormFieldEmail,
  FormFieldAHVNumber,
  useAppFormContext,
  AddressInfo,
  FormConfigStore,
  AppFormField,
  FormUtils,
  AppFileUploadField,
  DeliveryInfo,
 ShowError,
 Validators
} from 'ewp-common';
import OtherPersonInfo from './OtherPersonInfo';
import formDataStore from 'stores/formDataStore';

interface Props {
  id?: string;
  className?: string;
  additionalClassNames?: string;
  setAddress?: (val: any) => void;
  setRoute?: Dispatch<SetStateAction<number>>,
  selectFile?: (val: any) => void;
  cancel?: () => void;
  errorList?:any
}

const PersonalInfo = (props: Props) => {
  const {
    id,
    className,
    additionalClassNames,
  } = props;

  const {
    state: formConfigState,
  } = useContext(FormConfigStore.FormConfigContext);

  const {
    state: formDataState,
  } = useContext(formDataStore.FormDataContext);

  const configs = formConfigState?.data?.labelsMap;
  const { values } = useAppFormContext();

  const [mandatoryFields, setMandatoryFields] = useState(true);

  let showAhvNumber = false;
  if(process.env.REACT_APP_SHOW_AHV_NUMBER_FIELD == "1"){
    showAhvNumber = true;
  }

  return (
    <div id={id} className={classNames(className, additionalClassNames)}>
      <div className="mt-4">
        <h2>{configs.h2Personalien.labelDisplayName}</h2>
        <Fieldset>
          <AppFormField
            config={configs.fieldDeliveryCompany}
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            onChange={(val)=>{
              if(val.target.value){
                setMandatoryFields(false);
              } else{
                setMandatoryFields(true);
              }
            }}
          />
          <ToggleGroup
            name={FormUtils.getFieldName(configs.fieldAnrede)}
            label={configs.fieldAnrede.labelDisplayName}
            required={configs.fieldAnrede.mandatory === 'true' && mandatoryFields}
            infoText={configs.fieldAnrede.labelDescription}
            horizontal
          >
            <Toggle type="radio" value="Herr" label="Herr" />
            <Toggle type="radio" value="Frau" label="Frau" />
          </ToggleGroup>
          <AppFormField formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY} config={configs.fieldName} autocomplete="family-name" required={mandatoryFields}  />
          <AppFormField formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY} config={configs.fieldFirstname} autocomplete="given-name" required={mandatoryFields} />
          {configs?.fieldAhvNumber && showAhvNumber &&
          <FormFieldAHVNumber
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            fieldConfig={configs?.fieldAhvNumber}
            // initValue={formDataState.personal.fieldAhvNumber}
            mandatory={false}
          />}
          <DateField
            label={configs.fieldDob.labelDisplayName}
            name={FormUtils.getFieldName(configs.fieldDob)}
            placeholder={configs.fieldDob.labelDescription}
            validate={(e) => Validators.pastDateValidator(e,configs)}
            infoText={configs.fieldDob.labelDescription}
            required={mandatoryFields}
          />
          <AddressInfo
            fieldsConfig={configs}
            value={values?.personal}
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
          />
          <AppFormField
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            config={configs.fieldPhone}
            type="tel"
            prefillwith="+41 "
          />
          <FormFieldEmail
            formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
            fieldConfig={configs.fieldEmail}
          />
        </Fieldset>
        <OtherPersonInfo />
        <h2 className="mt-4">{configs.uploadHeading.labelDisplayName}</h2>
        <AppFileUploadField
          uploadFieldConfigs={configs.uploadfield}
          fieldsConfig={configs}
          formDataKey={FormUtils.PERSONAL_DATA_OBJ_KEY}
        />
        <DeliveryInfo
          formConfigs={configs}
        />
      </div>
    </div>
  );
};

PersonalInfo.defaultProps = {
  id: '',
  className: 'personalInfo',
  additionalClassNames: '',
};

export default PersonalInfo;
